<!-- z-30 keeps page content (positioned stat cards, sticky panels, tooltips) beneath the sidebar; z-40 lifts it above the mobile backdrop when open -->
<div class="flex flex-col w-80 bg-gray-800 text-white fixed top-[72px] bottom-0 left-0 z-30" [ngClass]="{'hidden lg:flex': !isMobileOpen(), 'flex z-40': isMobileOpen()}">
  <!-- Venue Dropdown: fixed header outside the scroll area, so nav items
       scroll in their own container below and never pass behind it -->
  <div class="relative p-4">
    <button
      (click)="toggleDropdown()"
      class="w-full flex items-center justify-between px-4 py-2 text-left bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
    >
      <span class="text-lg font-bold truncate" [title]="venueName">{{ venueName }}</span>
      <svg class="w-5 h-5 ml-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </button>

    @if (isDropdownOpen && venues$) {
      <div class="absolute top-full left-0 right-0 mt-2 bg-gray-700 rounded-lg shadow-lg max-h-64 overflow-y-auto z-50">
        <ul class="py-2">
          @for (venue of venues$ | async; track venue.id) {
            <li>
              <button
                (click)="selectVenue(venue)"
                class="w-full text-left px-4 py-2 hover:bg-gray-600 transition-colors"
                [ngClass]="{'bg-gray-600': venue.id === venueId}"
              >
                <span class="truncate block" [title]="venue.name">{{ venue.name }}</span>
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <!-- Scrollable navigation -->
  <div class="flex-1 min-h-0 overflow-y-auto px-4 pb-4 pt-2">
  @if (venueId) {
    <!-- Venue Home & Config -->
    <ul class="space-y-1">
      <li>
        <a
          [routerLink]="['/venues', venueId]"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 9.75l7.5-6 7.5 6M4.5 10.5v9a.75.75 0 00.75.75h2.25a.75.75 0 00.75-.75V13.5h3v6a.75.75 0 00.75.75h2.25a.75.75 0 00.75-.75v-9l-7.5-6-7.5 6z"></path>
          </svg>
          <span class="text-sm font-medium">Home</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['/venues', venueId, 'configuration']"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></path>
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
          <span class="text-sm font-medium">Configuration</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['/venues', venueId, 'activity-log']"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <span class="text-sm font-medium">Activity Log</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['/venues', venueId, 'migrations']"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"></path>
          </svg>
          <span class="text-sm font-medium">Migrations</span>
        </a>
      </li>
    </ul>

    <!-- Servicing Section -->
    <div class="mt-6">
      <h3 class="px-3 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">Servicing</h3>
      <ul class="space-y-1">
        <li>
          <a
            [routerLink]="['/venues', venueId, 'checkout']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 10.5h19.5M2.25 7.5h19.5M21.75 7.5v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25v-9M6 15h1.5m3 0h1.5"></path>
            </svg>
            <span class="text-sm font-medium">Checkout</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'plan']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m3-10h.01M5 10h.01m-.01 4h.01m2-6h10M4 6h16a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1z"></path>
            </svg>
            <span class="text-sm font-medium">Payment Plan</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'orders']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"></path>
            </svg>
            <span class="text-sm font-medium">Orders</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'terminals']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
            <span class="text-sm font-medium">Terminals</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'menu-items']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></path>
            </svg>
            <span class="text-sm font-medium">Menu Items</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'payment-summaries']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
            <span class="text-sm font-medium">Payment Summaries</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'staff']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"></path>
            </svg>
            <span class="text-sm font-medium">Staff</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'chat-audit']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"></path>
            </svg>
            <span class="text-sm font-medium">Chat Audit</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'genai-usage']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9.25 18l-.563-2.096a3.75 3.75 0 00-2.591-2.591L4 12.75l2.096-.563a3.75 3.75 0 002.591-2.591L9.25 7.5l.563 2.096a3.75 3.75 0 002.591 2.591l2.096.563-2.096.563a3.75 3.75 0 00-2.591 2.591zM18.259 8.715L18 9.75l-.259-1.035a2.625 2.625 0 00-1.706-1.706L15 6.75l1.035-.259a2.625 2.625 0 001.706-1.706L18 3.75l.259 1.035a2.625 2.625 0 001.706 1.706L21 6.75l-1.035.259a2.625 2.625 0 00-1.706 1.706zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"></path>
            </svg>
            <span class="text-sm font-medium">GenAI Usage</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'asset-usage']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"></path>
            </svg>
            <span class="text-sm font-medium">Asset Usage</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Testing Support Section -->
    <div class="mt-6">
      <h3 class="px-3 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">Testing Support</h3>
      <ul class="space-y-1">
        <li>
          <a
            [routerLink]="['/venues', venueId, 'raw-data']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5"></path>
            </svg>
            <span class="text-sm font-medium">Raw Data</span>
          </a>
        </li>
        <li>
          <a
            [routerLink]="['/venues', venueId, 'repro']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m-6 3.75l3 3m0 0l3-3m-3 3V1.5m6 9h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75"></path>
            </svg>
            <span class="text-sm font-medium">Repro</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Portal Quick Links Section -->
    <div class="mt-6">
      <h3 class="px-3 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">Portal Quick Links</h3>
      <ul class="space-y-1">
        <li>
          <a
            [href]="getPortalEditUrl(venueId)"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"></path>
            </svg>
            <span class="text-sm font-medium">Home</span>
          </a>
        </li>
        <li>
          <a
            [href]="getPortalSponsorshipsUrl(venueId)"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3 8h18M8.12 3.75a2.25 2.25 0 011.92-1.125h0a2.25 2.25 0 011.875 1.031L12 4.5l.085-.094a2.25 2.25 0 011.875-1.031h0a2.25 2.25 0 011.92 1.125M21 8v10.5a2.25 2.25 0 01-2.25 2.25h-13.5a2.25 2.25 0 01-2.25-2.25V8m0 0h18"></path>
            </svg>
            <span class="text-sm font-medium">Sponsorships</span>
          </a>
        </li>
        <li>
          <a
            [href]="getPortalMenuItemsUrl()"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"></path>
            </svg>
            <span class="text-sm font-medium">Menu Items</span>
          </a>
        </li>
      </ul>
    </div>
  }

  <!-- Trash Section -->
  <div class="mt-6">
    <h3 class="px-3 mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">System</h3>
    <ul class="space-y-1">
      @if (venueId) {
        <li>
          <a
            [routerLink]="['/venues', venueId, 'destruction-zone']"
            class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
          >
            <svg class="h-5 w-5 mr-2 text-red-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"></path>
            </svg>
            <span class="text-sm font-medium">Destruction Zone</span>
          </a>
        </li>
      }
      <li>
        <a
          routerLink="/archive"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400 group-hover:text-gray-200" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"></path>
          </svg>
          <span class="text-sm font-medium">Archive</span>
        </a>
      </li>
      <li>
        <a
          routerLink="/trash"
          class="flex items-center px-3 py-2 rounded-md transition-colors duration-200 hover:bg-gray-700 focus:bg-gray-700 outline-none cursor-pointer"
        >
          <svg class="h-5 w-5 mr-2 text-gray-400 group-hover:text-gray-200" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"></path>
          </svg>
          <span class="text-sm font-medium">Trash</span>
        </a>
      </li>
    </ul>
  </div>
  </div>
</div>